module.exports = __webpack_public_path__ + "img/FPT18.dc121ac3.svg";